/* eslint-disable react-refresh/only-export-components */
import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';

const RecordingPlayerContext = createContext(null);

export const RecordingPlayerProvider = ({ children }) => {
  const [current, setCurrent] = useState(null);

  const play = ({ callId, recordingUrl, label }) => {
    setCurrent({ callId, recordingUrl, label: label || null });
  };

  const close = () => setCurrent(null);

  return (
    <RecordingPlayerContext.Provider value={{ current, play, close }}>
      {children}
    </RecordingPlayerContext.Provider>
  );
};

RecordingPlayerProvider.propTypes = {
  children: PropTypes.node,
};

export const useRecordingPlayer = () => {
  const ctx = useContext(RecordingPlayerContext);
  if (!ctx) throw new Error('useRecordingPlayer must be used within RecordingPlayerProvider');
  return ctx;
};
